<div class="toggler-group">
  <ng-content></ng-content>
</div>
